import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SceneListService {

    selectedChanged$ = new Subject();

    deleteSelected$ = new Subject();

    constructor() {
    }

    selectScenes(ids) {
        
        this.selectedChanged$.next(ids);

    }

    deleteSelected() {
        
        this.deleteSelected$.next("delete");
    }
}
